export default build =>
    build.mutation({
        query(payload) {
            console.log("payload indelete lesson",payload)
            return {
                url: '/course/deleteLesson',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['courseById'],
       
    })
